import * as React from "react";
import { StyleSheet, View } from "react-native";
import routes from "../../routing/routes";
import { IconButton } from "react-native-paper";
import { iconLeft, iconSettings } from "../ModalIcons";

const ModalHeaderSettings = (props) => {
  const back = () => props.navigation.navigate(routes.Settings);

  return (
    <View style={styles.containerButtons}>
      <View style={styles.icons}>
        <IconButton icon={iconLeft} size={20} onPress={back} />
        <IconButton icon={iconSettings} size={20} />
      </View>
    </View>
  );
};

export default ModalHeaderSettings;

const styles = StyleSheet.create({
  containerButtons: {
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
  },
  icons: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: 30,
    width: 350,
  },
});
